const initialState = {
    pricedItems: [],
    isPricingDone: false,
};

const equityCartDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        default: {
            return { ...state };
        }
    }
};

export default equityCartDetailsReducer;
